// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// actions
import { chartDashboardActionList } from '../actions';

// apis
import { chartDashboardApi } from '../apis';

// models
import type { ResultError } from 'modules/common';
import type { ResProjectChartDashboard } from '../models';

/** 현장 차트 대시보드 데이터 조회 */
export const getProjectChartDashboard = createAsyncThunk<
  ResProjectChartDashboard,
  string,
  {
    rejectValue: ResultError;
  }
>(
  chartDashboardActionList.GET_CHART_DASHBOARD_PROJECT,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await chartDashboardApi.getChartDashboardData(data);

      const number = [7, 11, 7, 8, 5, 2, 2];

      const lastWeek = res.resultObject.weeklyEntry.lastWeek.map((item, idx) => ({
        ...item,
        totalEmployees: number[idx]
      }));

      return fulfillWithValue({
        ...res,
        resultObject: {
          ...res.resultObject,
          weeklyEntry: {
            ...res.resultObject.weeklyEntry,
            lastWeek
          }
        }
      });
    } catch (error) {
      return rejectWithValue(error as ResultError);
    }
  }
);
